import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';
import {
  ArticleMultilayerPlan,
  ArticleMultilayerPlanModel,
} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {queryKey} from './multilayer-plan-query-keys';

interface Props {
  form: ArticleMultilayerPlanModel;
  selection: (sharedId: string | null) => void;
}

export function useMultilayerPlanCreateMutation({form, selection}: Props) {
  const queryClient = useQueryClient();
  const {mutate, isPending, error, reset} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.post<ArticleMultilayerPlan>(`${environment.apiv4uri}multilayerplan`, form),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({queryKey: queryKey.lists()});
      selection(data.shared_id);
    },
  });

  return {
    createMutation: () => mutate(),
    createIsPending: isPending,
    createError: error,
    createReset: () => reset(),
  };
}
